<template>
  <div class="panel">
    <div class="panel-heading">{{heading}}</div>
    <div class="panel-body">
      <canvas ref="chart" :style="{height: '150px', width:'800px'}"></canvas>
    </div>
  </div>
</template>

<script>
  import Chart from 'chart.js'
  import * as data from '../../../client/src/data.js'
  import createHistogram from 'compute-histogram';
  export default {
    props: {
      allYields: Array,
      durationInMonths: Number
    },
    data () {
      return {
        NUM_HISTOGRAM_BUCKETS: 30,
        chart: null,
        options:  {
          animation: false,
          scales: {
            xAxes: [{
              categoryPercentage: 1.0,
              // This is required for the bars to 'touch' each other to
              // look more like bins in a histogram
              barPercentage: 1.03
            }]
          },
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: false
          },
          title: {
            display: false,
          }
        }
      };
    },
    methods: {
      createPercentageChangeDistribution(allYields, durationInMonths, numBuckets, limitTo95thPercentile) {
        const durationIndex = data.getDurationIndexFromMonths(durationInMonths);
        const getPercentageChangeFromYields = (yieldsForDay) => {
          const dateSlicedYields = yieldsForDay.slice(1);
          const value = dateSlicedYields[durationIndex][2];
          if (data.isNumber(value)) {
            return value;
          }
          return value;
        };

        const filteredYields = allYields.filter(yieldsForDay => {
          const value = getPercentageChangeFromYields(yieldsForDay);
          return data.isNumber(value);
        });

        const percentageChange = filteredYields.map(getPercentageChangeFromYields);
        return createHistogram(percentageChange,
          numBuckets,
          limitTo95thPercentile?0.05:0.0);
      },
      createChartDataAndLabels() {
        const returnVal = {data:[], labels:[]};
        const distribution = this.createPercentageChangeDistribution(this.allYields,
          this.durationInMonths,
          this.NUM_HISTOGRAM_BUCKETS,
          true /* this.limitDurationsTo95th */);
        distribution.forEach(xyVal => {
          returnVal.data.push(xyVal[1]);
          returnVal.labels.push(xyVal[0] + 1);
        });
        return returnVal;
      },
      createChart() {
        if (!this.allYields) return;
        const dataAndLabels = this.createChartDataAndLabels();
        this.chart = new Chart(this.$refs.chart, {
          type: 'bar',
          data: {
            labels: dataAndLabels.labels,
            datasets: [{
              backgroundOpacity: '.3',
              backgroundColor: 'rgba(74,135,208, .5)',
              data: dataAndLabels.data
            }]
          },
          options: this.options
        });
      }
    },
    watch: {
      allYields() {
        this.createChart();
      },
      durationInMonths() {
        this.createChart();
      }
    },
    computed: {
      heading() {
        if (!this.allYields) return '';

        return 'Distribution of % change in ' + data.getDurationLabel(this.durationInMonths) + ' Treasury bond yields';
      }
    }
  }
</script>

